// extracted by mini-css-extract-plugin
module.exports = {"root":"H2_root__FqUY7","smaller":"H2_smaller__TGUjP"};